<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-28 13:27:43
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-18 17:02:05
 * @FilePath: /wemeet-admin-new/src/views/data/components/channelDetail.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="dialogCard" style="margin-top: 20px; width: 100%">
    <div class="subBox">
      <div>
        <div class="title">
          <span>渠道明细</span>
          <el-tooltip content="用户访问人数、报名、签到等关键数据，连续多天的趋势" effect="dark" placement="top-start">
            <img
              alt=""
              class="tipsIcon"
              src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/tips.png"
            />
          </el-tooltip>
        </div>
        <!-- <div class="subTitle">更新时间：2024/05/11 09:40</div> -->
      </div>
      <div class="chooseTime">
        <span class="timeLabel">筛选条件</span>
        <el-select
          v-model="channelNo"
          clearable
          placeholder="选择渠道"
          size="large"
          style="width: 240px"
          @change="selectChange('channelCode')"
        >
          <el-option v-for="item in channelOption" :key="item.data" :label="item.label" :value="item.data" />
        </el-select>
        <el-select
          v-model="identity"
          clearable
          placeholder="选择身份"
          size="large"
          style="width: 240px; margin-left: 10px"
          @change="selectChange('identity')"
        >
          <el-option v-for="item in identityAll" :key="item.label" :label="item.name" :value="item.label" />
        </el-select>
        <el-date-picker
          v-model="timeRange"
          :disabled-date="disabledDate"
          end-placeholder="结束时间"
          range-separator="-"
          :shortcuts="shortcuts"
          size="large"
          start-placeholder="开始时间"
          style="margin-left: 10px"
          type="daterange"
          @calendar-change="handleChange"
          @change="pickerChange"
          @focus="handleFocus"
        />
        <el-button size="large" style="margin-left: 10px" type="primary" @click="exportRegister">导出</el-button>
      </div>
    </div>

    <div class="subBox" style="margin-top: 10px">
      <!-- <div class="chooseTime">
        <span class="timeLabel">编辑可见</span>
        <el-checkbox-group v-model="checkList" @change="changeGroup">
          <el-checkbox v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value" />
        </el-checkbox-group>
      </div> -->
    </div>

    <el-row>
      <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
        <div class="tableData">
          <el-table :data="tableData" style="width: 100%; margin-top: 10px">
            <template v-for="item in tableColumn" :key="item.value">
              <el-table-column v-if="item.show" :label="item.label" :prop="item.prop" />
            </template>
          </el-table>

          <el-pagination background :layout="layout" :total="total" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { defineComponent, reactive, toRefs, watch } from 'vue'
  import _ from 'lodash'
  import VabChart from '@/extra/VabChart'
  import VabCount from '@/extra/VabCount'
  import { reportMeetingChannelDetail } from '@/api/workBench'
  import { parseTime } from '@/utils/index'
  import { getIdentity } from '@/api/channel'
  export default defineComponent({
    components: {
      VabChart,
      VabCount,
    },
    props: {
      channelList: {
        type: Array,
        default: [],
      },
      identityList: {
        type: Array,
        default: [],
      },
      meetingCode: {
        type: String,
        default: '',
      },
      meetingType: {
        type: String,
        default: 'EXHIBITION',
      },
    },
    setup(props, { emit }) {
      watch(
        () => [props.channelList, props.identityList],
        ([newVal, identityNew]) => {
          console.log(identityNew, '123')
          state.identityAll = JSON.parse(JSON.stringify(identityNew))
          state.channelOption = JSON.parse(JSON.stringify(newVal))
          state.queryForm.meetingCode = props.meetingCode
          state.queryForm.meetingType = props.meetingType
          queryData()
        }
      )
      const state = reactive({
        channelOption: [],
        identity: '',
        channelNo: '',
        timeRange: [null, null],
        checkList: [`新增报名人数`, `累计报名人数`, `新增签到人数`, `累计签到人数`],
        fillColor: '#00C4C9',
        shortcuts: [
          {
            text: '上一周',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setDate(start.getDate() - 7)
              return [start, end]
            },
          },
          {
            text: '上个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 1)
              return [start, end]
            },
          },
        ],
        value: '',
        tableData: [],
        tableColumn: [
          {
            prop: 'date',
            label: '日期',
            show: true,
            fixed: true,
          },
          {
            prop: 'channelName',
            label: '注册渠道',
            show: true,
            fixed: true,
          },
          {
            prop: 'identityName',
            label: '注册身份',
            show: true,
            fixed: true,
          },
          {
            prop: 'signUpNum',
            label: '新增注册人数',
            show: true,
            fixed: false,
          },
          {
            prop: 'totalSignUpNum',
            label: '累计注册人数',
            show: true,
            fixed: false,
          },
          {
            prop: 'signInNum',
            label: '新增签到人数',
            show: true,
            fixed: false,
          },
          {
            prop: 'totalSignInNum',
            label: '累计签到人数',
            show: true,
            fixed: false,
          },
        ],
        queryForm: {
          channelNo: '',
          endTime: '',
          identity: '',
          meetingCode: '',
          meetingType: '',
          pageNum: 1,
          pageSize: 20,
          startTime: '',
        },
        layout: 'prev, pager, next',
        total: 0,
        chooseDay: null,
        identityAll: [],
      })

      window.onresize = () => {
        console.log(`resize`)
      }

      const queryData = async () => {
        const { data } = await reportMeetingChannelDetail(state.queryForm)
        data.data.forEach((v) => {
          v.identityName = state.identityAll.filter((iv) => iv.label == v.identity)[0].name
        })
        state.tableData = data.data
        state.total = data.total
      }

      const handleChange = (val) => {
        console.log(val)
        const [pointDay] = val
        state.chooseDay = pointDay
        console.log(pointDay)
      }

      const pickerChange = (val) => {
        console.log(val, '=-==')
        state.queryForm.startTime = parseTime(val[0])
        state.queryForm.endTime = parseTime(val[1])
        state.queryForm.pageNum = 1
        queryData()
      }
      //取值方法
      const handleFocus = () => {
        state.chooseDay = null
      }
      const disabledDate = (time) => {
        if (!state.chooseDay) {
          return false
        }
        let timeRange = 30
        const con1 = new Date(state.chooseDay).getTime() - timeRange * 24 * 60 * 60 * 1000
        const con2 = new Date(state.chooseDay).getTime() + timeRange * 24 * 60 * 60 * 1000
        return time < con1 || time > con2
      }

      const selectChange = (type) => {
        if (type == 'identity') {
          state.queryForm.identity = state.identity
        } else {
          state.queryForm.channelNo = state.channelNo
        }

        state.queryForm.pageNum = 1
        queryData()
      }

      const exportRegister = () => {
        emit('exportRegister', state.queryForm)
      }

      return {
        ...toRefs(state),
        handleChange,
        handleFocus,
        disabledDate,
        pickerChange,
        selectChange,
        exportRegister,
      }
    },
  })
</script>

<style lang="scss">
  .dialogCard {
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #00c4c9;
      border-color: #00c4c9;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #00c4c9;
    }
  }
</style>

<style lang="scss" scoped>
  .dialogCard {
    width: 100%;
    min-height: 174px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;
    box-sizing: border-box;
    .subBox {
      // display: flex;
      // justify-content: space-between;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        .tipsIcon {
          width: 18px;
          height: 18px;
          margin-left: 8px;
        }
      }
      .subTitle {
        font-size: 12px;
        color: #4e5969;
      }
      .chooseTime {
        display: flex;
        align-items: center;
        margin-top: 20px;
        .timeLabel {
          font-size: 14px;
          color: #4e5969;
          margin-right: 16px;
        }
      }
    }
    .tableData {
      width: 100%;
      .question {
        font-size: 14px;
        color: #1d2129;
        margin-top: 20px;
      }
    }
  }
</style>
